import { useReducer, useRef, useEffect } from 'react';

const useReducerWithMiddleware = ({
  reducer,
  initialState,
  middlewareFns,
  afterwareFns
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const aRef = useRef();
  const dispatchWithMiddleware = action => {
    middlewareFns === null || middlewareFns === void 0 ? void 0 : middlewareFns.forEach(middlewareFn => middlewareFn(action));
    aRef.current = action;
    dispatch(action);
  };
  useEffect(() => {
    if (!aRef.current) return;
    afterwareFns === null || afterwareFns === void 0 ? void 0 : afterwareFns.forEach(afterwareFn => afterwareFn(state, aRef.current));
    aRef.current = null;
  }, [afterwareFns, state]);
  return [state, dispatchWithMiddleware];
};

export { useReducerWithMiddleware };
